
function get(key) {

  return JSON.parse(sessionStorage.getItem(key))

}

function set(key,value) {
  return sessionStorage.setItem(key,JSON.stringify(value))
}

export function getMenuList() {
  return get('menuList')


}
export function setMenuList(list){
  return set('menuList',list)

}
export function getApiList() {
  return get('apiList')
}
export function setApiList(data){
  return set('apiList',data)

}



//
// export function setRouters(data){
//   console.log(3333)
//   return set('routers',data)
//
// }
// export function getRouters() {
//   console.log(66666)
//   console.log(get('routers'))
//   return get('routers')
// }
// export function setAddRouters(data){
//   return set('addRouters',data)
//
// }
// export function getAddRouters() {
//   return get('addRouters')
// }
